module.exports = __webpack_public_path__ + "static/media/arquitect_1.93620e5d.jpeg";